import { create } from "zustand";

const sidebarActivePage = create((set) => ({
  isActive: "",

  setIsActive: ({ setPage }) => {
    set({ isActive: setPage });
  },
}));

export default sidebarActivePage;
